import React from 'react';

export const DownloadInfo = ({ onSupportedSitesClick }) => {
    return (
        <section className="downloader-info fade-in">
            <div className="downloader-info__card">
                <div className="downloader-info__header">
                    <h2>CutIQ Downloader</h2>
                    <p>
                        Download crisp MP4 video or high-fidelity MP3 audio from the sites you love, on desktop or mobile.
                        CutIQ keeps the original quality whenever it's available and automatically adjusts for each platform.
                    </p>
                </div>

                <ul className="downloader-info__features">
                    <li>One-click playlists & single videos</li>
                    <li>Video + audio quality controls</li>
                    <li>Watermark-free downloads (paid)</li>
                    <li>Works in any modern browser</li>
                </ul>

                <div className="downloader-info__how-to">
                    <h3>How to use CutIQ</h3>
                    <ol>
                        <li>
                            <strong>Find it.</strong> Copy the URL of the video, short, reel, or playlist you want to download.
                        </li>
                        <li>
                            <strong>Paste it.</strong> Drop the link into CutIQ. We'll instantly fetch all available formats.
                        </li>
                        <li>
                            <strong>Download it.</strong> Select your quality and hit Download. Your file is ready in seconds.
                        </li>
                    </ol>
                </div>

                <div className="downloader-info__footer">
                    <p className="downloader-info__note">
                        <button type="button" className="inline-link" onClick={onSupportedSitesClick}>
                            View All Supported Sites
                        </button>
                    </p>
                    <p className="downloader-info__terms">
                        By using our service, you agree to our{' '}
                        <a href="/terms" target="_blank" rel="noreferrer">
                            Terms of Use
                        </a>
                        .
                    </p>
                </div>
            </div>
        </section>
    );
};
